<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i
							class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="tornaAProgetti()">
						<Translate :path="'dizionario.progetti.PROGETTI'"></Translate> </a>
					<span class="hidden-xs ms-1">\</span>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer ms-1"
						v-on:click="tornaAProgetti()"> {{ progetto.TITOLO }} </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">
						<Translate :path="'dizionario.base.ELENCO'"></Translate> <Translate :path="'dizionario.attivita.ATTIVITA'"></Translate>
					</span>
					<span v-if="revisioneCorrente" class="badge bg-primary ms-2" style="font-size:0.7rem;">Rev. {{
						revisioneCorrente.PROGRESSIVO }}<span v-if="revisioneCorrente.PROGRESSIVO_PADRE"> (Copia della rev {{ revisioneCorrente.PROGRESSIVO_PADRE }})</span></span>
					<span v-if="revisioneCorrente && revisioneCorrente.FLG_PUBBLICATA == 1" class="badge bg-danger ms-1"
						style="font-size:0.7rem;"><Translate :path="'dizionario.base.CONGELATA'"></Translate></span>
					<span
						v-if="revisioneVisualizzata && revisioneCorrente && revisioneVisualizzata.ID_REVISIONE != revisioneCorrente.ID_REVISIONE"
						class="badge bg-warning text-dark ms-1" style="font-size:0.7rem;">Visualizzi Rev. {{
							revisioneVisualizzata.PROGRESSIVO }}<span v-if="revisioneVisualizzata.PROGRESSIVO_PADRE"> (Copia della rev {{ revisioneVisualizzata.PROGRESSIVO_PADRE }})</span></span>
				</h4>
				<a href="#page_header"
					class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto"
					data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10"
						style="text-align: left;"
						v-if="!(revisioneVisualizzata && revisioneCorrente && revisioneVisualizzata.ID_REVISIONE != revisioneCorrente.ID_REVISIONE)"
						v-on:click="apriSceltaTipoCreazione()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<Translate :path="'dizionario.base.BTN_ADD'" class="me-1"></Translate>
								<Translate :path="'dizionario.base.BTN_NUOVO'"></Translate>
							</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.attivita.ATTIVITA'"></Translate></div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill"
							v-on:click="$root.confTravelTipologiche(11)" title="Opzioni Progetti"
							data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2"
							v-on:click="$root.confTravelLingue(11)" title="Definizioni Lingua" data-bs-toggle="tooltip"
							data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2"
							v-on:click="$root.help(11)" title="Help OnLine" data-bs-toggle="tooltip"
							data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer"
							data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1"
							v-on:click="tornaAProgetti()">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1"><Translate :path="'dizionario.progetti.PROGETTI'"></Translate></span>
								<span class="hidden-xs ms-1">
									<Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate><Translate :path="'dizionario.progetti.PROGETTI'"></Translate>
								</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a href="#activities-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded"
							data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list-checks"></i>
								<span class="hidden-lg ms-1"><Translate :path="'dizionario.attivita.ATTIVITA'"></Translate></span>
								<span class="hidden-xs ms-1">
									<Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate><Translate :path="'dizionario.attivita.ATTIVITA'"></Translate>
								</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav"
							class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed"
							data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>



				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item ms-lg-1">
							<a v-if="revisioneCorrente && revisioneCorrente.FLG_PUBBLICATA == 0"
								href="#"
								@click.prevent="creaRevisione()"
								class="navbar-nav-link rounded"
								title="Crea nuova revisione"
							>
								<i class="ph-git-branch me-2"></i>
								<span class="d-none d-lg-inline"><Translate :path="'dizionario.attivita.NUOVA_REVISIONE'"></Translate></span>
							</a>
						</li>
						<li class="nav-item ms-lg-3">
							<a href="#"
								@click.prevent="filters.openPopUp('popUpStorico')"
								class="navbar-nav-link rounded"
								title="Visualizza storico revisioni"
							>
								<i class="ph-clock-counter-clockwise me-2"></i>
								<span class="d-none d-lg-inline"><Translate :path="'dizionario.attivita.STORICO_REVISIONI'"></Translate></span>
							</a>
						</li>
						<li class="nav-item dropdown ms-lg-3">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle"
									data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;"><Translate :path="'dizionario.base.AZIONI_MULTIPLE'"></Translate></span>
								</a>
								<div class="dropdown-menu dropdown-menu-end" style="">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i
												class="fad fa-ballot-check fa-fw me-2"></i><span
												class="text-muted me-1">|</span><Translate :path="'dizionario.base.STATO'"></Translate></a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i
													class="far fa-check-square fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.ATTIVA_SELEZIONATI'"></Translate></a>
											<a href="#" class="dropdown-item"><i
													class="far fa-square fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.DISATTIVA_SELEZIONATI'"></Translate></a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i
												class="fad fa-file-export fa-fw me-2"></i><span
												class="text-muted me-1">|</span><Translate :path="'dizionario.base.COMUNICAZIONI'"></Translate></a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.INVIA_EMAIL'"></Translate></a>
											<a href="#" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.INVIA_SMS'"></Translate></a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="fad fa-print fa-fw me-2"></i><span
												class="text-muted me-1">|</span><Translate :path="'dizionario.base.STAMPE'"></Translate></a>
										<div class="dropdown-menu">
											<a v-on:click="apriModalitaEsportazione()" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.ESPORTA_EXCEL'"></Translate></a>
											<div class="dropdown-divider"></div>
											<a v-on:click="scaricaTemplateOffline()" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2 text-success"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.SCARICA_TEMPLATE'"></Translate></a>
											<a v-on:click="apriImportaExcelOffline()" class="dropdown-item"><i
													class="ph-upload-simple fa-fw me-2 text-success"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.IMPORTA_EXCEL_OFFLINE'"></Translate></a>
											<!-- <a v-on:click="stampeOrdine(1010)" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2"></i><span
													class="text-muted me-1">|</span>Genera Excel</a> -->
											<a v-on:click="esportaBudgetPdf()" class="dropdown-item"><i
													class="far fa-file-pdf fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.STAMPA_BUDGET'"></Translate></a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item"><i
											class="fad fa-trash fa-fw me-2 text-danger"></i><span
											class="text-muted me-1">|</span><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate></a>
								</div>
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->

	</div>
	<!-- /page header -->

	<!-- Content area -->
	<div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="progetti-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1" v-show="!editMode">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse"
								role="button" aria-expanded="false">
								<Translate :path="'dizionario.base.MOSTRA_FILTRI'"></Translate>
							</a>
						</div>
					</div>

					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all">
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="progetto-a">
									<div class="row">
										<!-- Filtri (nascosti quando editMode = true) -->
										<div v-if="!editMode" class="col-12">
											<div class="row">
												<div class="col-5 col-md-1 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="'Id ' + $root.translate('dizionario.attivita.ATTIVITA')" :tabindex="1"
														v-model="search.ID_ATTIVITA.VALUE" />
												</div>
												<div class="col-7 col-md-1 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="'Id ' + $root.translate('dizionario.attivita.VOCE')" :tabindex="2" v-model="search.ID_VOCE.VALUE" />
												</div>
												<div class="col-12 col-md-2 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="$root.translate('dizionario.attivita.ATTIVITA')" :tabindex="4" v-model="search.TITOLO.VALUE" />
												</div>
												<div class="col-12 col-md-2 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="$root.translate('dizionario.attivita.VOCE')" :tabindex="4" v-model="search.TITOLO_VOCE.VALUE" />
												</div>
												<div class="col-12 col-md-1 mbx-1">
													<select class="form-control form-control-sm" :tabindex="5"
														v-model="search.FLG_DA_CALCOLARE.VALUE">
														<option value="">{{ $root.translate('dizionario.attivita.CALCOLO') }}</option>
														<option value="1">{{ $root.translate('dizionario.base.SI') }}</option>
														<option value="0">{{ $root.translate('dizionario.base.NO') }}</option>
													</select>
												</div>
												<div class="col-12 col-md-1 mbx-1" v-if="$root.isGod">
													<select class="form-control form-control-sm" v-model="search.FLG_ELIMINATO.VALUE">
														<option value="0">{{ $root.translate('dizionario.attivita.NON_ELIMINATE') }}</option>
														<option value="">{{ $root.translate('dizionario.base.TUTTE') }}</option>
														<option value="1">{{ $root.translate('dizionario.attivita.ELIMINATE') }}</option>
													</select>
												</div>
												<div v-if="!isReadOnly" class="col-12 mbx-1 d-flex justify-content-end align-items-center"
													:class="$root.isGod ? 'col-md-4' : 'col-md-5'">
													<button
														@click="editMode = true"
														class="btn btn-primary btn-sm"
														title="Abilita riordino (disabilita filtri)"
													>
														<i class="ph-arrows-out-cardinal me-1"></i>
														<span class="d-none d-lg-inline"><Translate :path="'dizionario.attivita.ABILITA_RIORDINO'"></Translate></span>
													</button>
												</div>
											</div>
										</div>

										<!-- Pulsanti riordino (visibili quando editMode = true) -->
										<div v-if="editMode && !isReadOnly" class="col-12">
											<div class="d-flex gap-2 align-items-center p-2" style="background-color: #f0f7ff; border-radius: 4px;">
												<span class="text-warning fw-semibold flex-grow-1">
													<i class="ph-warning me-1"></i>
													Modalità riordino attiva - i filtri sono disabilitati
												</span>
												<button
													@click="disabilitaRiordino"
													class="btn btn-secondary btn-sm"
													title="Disabilita riordino (riabilita filtri)"
												>
													<i class="ph-x me-1"></i>
													<span class="d-none d-lg-inline"><Translate :path="'dizionario.attivita.ANNULLA_RIORDINO'"></Translate></span>
												</button>
												<button
													@click="salvaOrdinamento"
													:disabled="!hasUnsavedChanges || saving"
													class="btn btn-success btn-sm"
													:class="{ 'pulse': hasUnsavedChanges }"
													title="Salva ordinamento attività e voci"
												>
													<i class="ph-floppy-disk me-1"></i>
													<span class="d-none d-lg-inline">{{ saving ? 'Salvataggio...' : $root.translate('dizionario.attivita.SALVA_ORDINAMENTO') }}</span>
													<span v-if="hasUnsavedChanges" class="badge bg-warning ms-1 d-none d-lg-inline">!</span>
												</button>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead" style="min-height: 200px; max-height: calc(100vh - 390px);">
							<table class="table table-togglable table-bordered" style="table-layout: fixed;">
								<colgroup>
									<col style="width: 3%;">
									<col style="width: 37%;">
									<col style="width: 5%;">
									<col style="width: 5%;">
									<col style="width: 7%;">
									<col style="width: 9%;">
									<col style="width: 7%;">
									<col style="width: 7%;">
									<col style="width: 7%;">
									<col style="width: 8%;">
									<col style="width: 5%;">
								</colgroup>
								<thead v-if="!$root.isMobile" class="sticky-top thead-bordered">
									<tr class="text-white">
										<th class="table-head-sm text-center bg-secondary" style="width:3%;" rowspan="2">
											<input type="checkbox" v-model="allExpanded" title="Espandi/Chiudi tutte" />
										</th>
										<th class="table-head-sm text-center bg-secondary" style="width:37%;" rowspan="2"><Translate :path="'dizionario.base.TITOLO'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:26%; border-right: 20px solid white !important;" colspan="4"><Translate :path="'dizionario.attivita.VENDITA'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:35%; border-left: 20px solid white !important;" colspan="4"><Translate :path="'dizionario.attivita.ACQUISTO'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:5%;" rowspan="2"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
									</tr>
									<tr class="text-white">
										<th class="table-head-sm text-center bg-secondary" style="width:5%; border-left: 1px solid white; border-right: 1px solid white;"><Translate :path="'dizionario.attivita.QUANTITA'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:5%; border-left: 1px solid white; border-right: 1px solid white;"><Translate :path="'dizionario.attivita.GIORNI'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:8%; border-left: 1px solid white; border-right: 1px solid white;"><Translate :path="'dizionario.attivita.PREZZO_UNIT'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:8%; border-left: 1px solid white; border-right: 20px solid white !important;"><Translate :path="'dizionario.attivita.TOTALE'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:7%; border-left: 20px solid white !important; border-right: 1px solid #FFD648;"><Translate :path="'dizionario.attivita.COSTO_UNIT'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:7%; border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;"><Translate :path="'dizionario.attivita.COSTI'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:7%; border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:7%; border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;"><Translate :path="'dizionario.base.FORNITORE'"></Translate></th>
									</tr>
								</thead>
								<tbody>
									<!-- Static empty placeholder (only visible when no attività and in editMode) -->
									<tr v-if="(!attivitaList || attivitaList.length == 0) && editMode">
										<td colspan="11" class="p-3">
											<div class="empty-attivita-placeholder">
												<span><Translate :path="'dizionario.attivita.TRASCINA_ATTIVITA_QUI'"></Translate></span>
											</div>
										</td>
									</tr>
									<tr>
										<td class="p-0 m-0" colspan="11">
											<draggable
												:key="`root-drag-${editMode}`"
												tag="div"
												:list="attivitaList"
												handle=".drag-handle-attivita"
												:disabled="!editMode"
												group="attivita"
												:animation="200"
												ghostClass="sortable-ghost"
												chosenClass="sortable-chosen"
												dragClass="sortable-drag"
												itemKey="ID_ATTIVITA"
												:fallbackOnBody="true"
												:removeCloneOnHide="true"
												@start="onRootAttivitaDragStart"
												@end="onRootAttivitaDragEnd"
												@change="onRootAttivitaChange"
												:move="onRootAttivitaMove"
												class="root-attivita-container"
												:class="{ 'root-attivita-empty': (!attivitaList || attivitaList.length == 0) && draggingRootAttivita }"
											>
												<!-- Placeholder quando vuoto e in drag -->
												<div v-if="(!attivitaList || attivitaList.length == 0) && draggingRootAttivita" class="root-drop-placeholder">
													<span><Translate :path="'dizionario.attivita.TRASCINA_ROOT'"></Translate></span>
												</div>

												<AttivitaNode
													v-for="attivita in attivitaList"
													:key="attivita.ID_ATTIVITA"
													:attivita="attivita"
													:depth="0"
													:progetto="progetto"
													:force-expanded="allExpanded"
													:read-only="isReadOnly"
													:drag-enabled="editMode && !isReadOnly"
													:dragging-attivita-from-parent="draggingRootAttivita"
													@refresh="getAttivita"
													@mark-unsaved-changes="hasUnsavedChanges = true"
													@apri-azioni="apriAzioni"
													@apri-azioni-voce="apriAzioniVoce"
													@crea-voce="creaVoce"
													@modifica-voce="modificaVoce"
													@elimina-voce="eliminaVoce"
												/>
											</draggable>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<NoteSpeseProg v-if="!isReadOnly" :arrayNoteSpese="arrayNoteSpese" @apri-azioni="apriAzioniSpesa" />

						<div class="row page-bottom mt-2">
							<div class="col-12 col-md-7 d-none d-sm-block" :tabindex="27">
								<div style="position: relative; top: 10px; white-space: nowrap; overflow-x: auto;">
									<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2">
										<Translate :path="'dizionario.attivita.BUDGET'"></Translate>: &euro; {{ showIva && getTotali.TOTALE_IVA > 0 ? getTotali.TOTALE_CON_IVA : getTotali.BUDGET }}
									</span>
									<span class="badge bg-info bg-opacity-20 text-info rounded-0 p-2 me-2"
										title="Somma delle fee applicate a ogni voce"
										data-bs-toggle="tooltip" data-bs-placement="top">
										<Translate :path="'dizionario.attivita.FEE'"></Translate>: &euro; {{ getTotali.FEE }}
									</span>
									<span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2 me-2">
										<Translate :path="'dizionario.attivita.GRAND_TOTAL'"></Translate>: &euro; {{ showIva && getTotali.TOTALE_IVA > 0 ? getTotali.TOTALE_CON_IVA : getTotali.GRAND_TOTAL }}
									</span>
									<span
										class="badge bg-danger bg-opacity-20 text-danger rounded-0 p-2 me-2"
										:title="getPct(getTotali.COSTO_ESPOSTO)"
										data-bs-toggle="tooltip" data-bs-placement="top">
										<Translate :path="'dizionario.attivita.ACQUISTO'"></Translate>: &euro; {{ showIva && getTotali.TOTALE_IVA_COSTO > 0 ? getTotali.TOTALE_CON_IVA_COSTO : getTotali.COSTO_ESPOSTO }}
									</span>
									<span
										class="badge bg-warning bg-opacity-20 text-warning rounded-0 p-2 me-2"
										:title="getPct(getTotali.COSTO_PRIVATO)"
										data-bs-toggle="tooltip" data-bs-placement="top">
										<Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate>: &euro; {{ showIva && getTotali.TOTALE_IVA_COMMISSIONI > 0 ? getTotali.TOTALE_CON_IVA_COMMISSIONI : getTotali.COSTO_PRIVATO }}
									</span>
									<span
										class="badge bg-success bg-opacity-20 text-success rounded-0 p-2 me-2"
										@click="toggleMarginePercentage()"
										:title="getMarginePercentage() + '% del budget'"
										data-bs-toggle="tooltip" data-bs-placement="top"
										style="cursor: pointer; user-select: none;">
										<Translate :path="'dizionario.attivita.MARGINE'"></Translate>: <span v-if="!showMarginePercentage">&euro; {{ getTotali.MARGINE }}</span><span v-else>{{ getMarginePercentage() }}%</span>
									</span>
									<button v-if="getTotali.TOTALE_IVA > 0 || getTotali.TOTALE_IVA_COSTO > 0 || getTotali.TOTALE_IVA_COMMISSIONI > 0"
										class="btn btn-sm ms-2"
										:class="showIva ? 'btn-success' : 'btn-secondary'"
										@click="showIva = !showIva"
										style="cursor: pointer; user-select: none;"
										title="Mostra/nascondi valori IVA inclusa"
										data-bs-toggle="tooltip" data-bs-placement="top">
										{{ $root.translate(showIva ? 'dizionario.attivita.NASCONDI_IVA' : 'dizionario.attivita.MOSTRA_IVA') }}
									</button>
								</div>
							</div>
							<div v-if="!editMode" class="col-9 col-md-4" :tabindex="27">
								<div class=" float-end pag-mobile">
									<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
										:numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
								</div>
							</div>
							<div v-else class="col-9 col-md-4" :tabindex="27">
								<div class="float-end text-warning">
									<i class="ph-warning me-1"></i>
									<small>Modalità riordino attiva - Filtri disabilitati</small>
								</div>
							</div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end"
									data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE"
									style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
									<option value="5">5</option>
									<option value="10">10</option>
									<option value="25">25</option>
									<option value="50">50</option>
									<option value="75">75</option>
									<option value="100">100</option>
									<option value="250">250</option>
									<option value="500">500</option>
								</select>
							</div>
						</div>

					</div>


				</div>
			</div>

		</div>
	</div>




	<!-- START MODALI -->
	<div class="modal fade" id="popUpAttivita" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0 py-2">
					<h6 class="modal-title mb-0">
						<i class="ph-list me-2"></i>
						<span class="ms-1 me-1">{{ $root.translate(attivitaSelezionata.ID_ATTIVITA > 0 ? 'dizionario.base.BTN_MODIFICA' : 'dizionario.base.BTN_NUOVA') }}</span><Translate :path="'dizionario.attivita.ATTIVITA'"></Translate> - <small class="text-white-50">{{ progetto.TITOLO }}</small>
					</h6>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
						data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-3">

					<div class="mb-2">
						<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.TITOLO_ATTIVITA'"></Translate> <span class="text-danger">*</span></label>
						<input type="text" class="form-control form-control-sm" v-model="attivitaSelezionata.TITOLO"
							placeholder="Inserisci il titolo dell'attività" @keyup.enter="salvaAttivita(false)">
					</div>

					<div class="row mb-2">
						<div class="col-12 col-md-6">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.ATTIVITA_PADRE'"></Translate></label>
							<select class="form-select form-select-sm" v-model="attivitaSelezionata.FK_ID_ATTIVITA">
								<option :value="null">{{ $root.translate('dizionario.attivita.NESSUNA_RADICE') }}</option>
								<option v-for="att in attivitaFlat" :key="att.ID_ATTIVITA" :value="att.ID_ATTIVITA"
									:disabled="att.ID_ATTIVITA == attivitaSelezionata.ID_ATTIVITA">{{ att.TITOLO }}
								</option>
							</select>
						</div>
						<div class="col-12 col-md-6">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.CITTA'"></Translate></label>
							<Select2 v-model="attivitaSelezionata.FK_ID_CITTA" :w="250" :api="'core/geo/comuni/select2'"
								:apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'">
							</Select2>
						</div>
					</div>

					<div class="mb-2">
						<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.DESCRIZIONE'"></Translate></label>
						<textarea class="form-control form-control-sm" v-model="attivitaSelezionata.DESCRIZIONE" rows="2"
							placeholder="Descrizione opzionale dell'attività"></textarea>
					</div>

					<div class="row mb-2 align-items-end">
						<div class="col-12 col-md-8">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.COLORE'"></Translate></label>
							<div class="d-flex align-items-center">
								<input type="color"
									class="form-control form-control-color"
									v-model="attivitaSelezionata.COLORE"
									:title="$root.translate('dizionario.attivita.COLORE')"
									style="width: 50px; height: 32px;">
								<input type="text"
									class="form-control form-control-sm ms-2"
									v-model="attivitaSelezionata.COLORE"
									placeholder="#A5A5A5"
									maxlength="7"
									style="width: 100px;">
								<span class="ms-2 text-muted small"><Translate :path="'dizionario.attivita.COLORE_SFONDO'"></Translate></span>
							</div>
						</div>
						<div class="col-12 col-md-4 mt-2 mt-md-0">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.INCLUDI_CALCOLO'"></Translate></label>
							<div>
								<ISwitch v-model="attivitaSelezionata.FLG_DA_CALCOLARE" style="z-index:0;"></ISwitch>
							</div>
						</div>
					</div>
				</div>


				<div class="modal-footer py-2">
					<button type="button" class="btn btn-sm btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i>
						<Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
					<button type="button" class="btn btn-sm btn-secondary" @click="salvaAttivita(false)"
						:disabled="!attivitaSelezionata.TITOLO">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CHIUDI'"></Translate>
					</button>
					<button v-if="attivitaSelezionata.ID_ATTIVITA == 0" type="button" class="btn btn-sm btn-primary" @click="salvaAttivita(true)"
						:disabled="!attivitaSelezionata.TITOLO">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CONTINUA'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div>


	<!-- Modal Nuova/Modifica Voce -->
	<div class="modal fade" id="popUpVoce" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0 py-2">
					<h6 class="modal-title mb-0">
						<i class="ph-plus-circle me-2"></i>
						{{ $root.translate(voceSelezionata.ID_VOCE > 0 ? 'dizionario.base.BTN_MODIFICA' : 'dizionario.base.BTN_NUOVA') }} <Translate :path="'dizionario.attivita.VOCE'"></Translate> - <small class="text-white-50">{{ attivitaPerVoce.TITOLO }}</small>
					</h6>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-3">
					<div class="row mb-2">
						<div class="col-12 col-md-6">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.TITOLO'"></Translate> <span class="text-danger">*</span></label>
							<textarea class="form-control form-control-sm" v-model="voceSelezionata.TITOLO_VOCE"
								rows="7" placeholder="Inserisci il titolo della voce" style="resize: vertical;"></textarea>
						</div>
						<div class="col-12 col-md-6">
							<div class="mb-2">
								<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.NOTE'"></Translate></label>
								<input type="text" class="form-control form-control-sm" v-model="voceSelezionata.NOTE"
									placeholder="Inserisci eventuali note">
							</div>
							<div class="mb-2">
								<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.CLIENTE'"></Translate></label>
								<input type="text" class="form-control form-control-sm bg-light" :value="progetto.CLIENTE || 'N/A'" readonly>
							</div>
							<div>
								<label class="form-label fw-semibold mb-1" style="width:100%;"><Translate :path="'dizionario.base.FORNITORE'"></Translate>
									<spam class="badge bg-success badge-xs cursor-pointer float-end" @click="apriNuovoFornitore" title="Crea nuovo fornitore">{{ $root.translate('dizionario.base.BTN_NUOVA') }}</spam>
								</label>
								<Select2 v-model="voceSelezionata.FK_ID_AZIENDA_FORNITORE" :api="'theb/s2/fornitori'"
									:apiselected="'theb/s2/fornitori/selected'"></Select2>
							</div>
						</div>
					</div>

					<div class="row mb-2">
						<div class="col-12 col-md-4 d-flex align-items-center gap-2">
							<label class="form-label fw-semibold mb-0 me-2"><Translate :path="'dizionario.attivita.INCLUDI_CALCOLO'"></Translate></label>
							<ISwitch v-model="voceSelezionata.FLG_DA_CALCOLARE" style="z-index:0;"></ISwitch>
						</div>
					</div>

					<h6 class="fw-semibold text-primary mb-1 mt-2"><i class="ph-currency-circle-dollar me-1"></i><Translate :path="'dizionario.attivita.VENDITA'"></Translate></h6>
					<div class="row mb-2">
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.QTA'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="voceSelezionata.QUANTITY_PRICE" placeholder="1"
								@input="calcolaTotalePrezzo()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.RIP'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="voceSelezionata.DAYS_PRICE" placeholder="1"
								@input="calcolaTotalePrezzo()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COSTO'"></Translate>
								<spam
									class="badge badge-xs cursor-pointer float-end"
									:class="voceSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? 'bg-success' : 'bg-secondary'"
									@click="toggleOmaggio('UNIT_PRICE')"
									:title="voceSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? 'Clicca per disattivare omaggio' : 'Clicca per impostare come omaggio'"
								>{{ $root.translate('dizionario.attivita.OMAGGIO_LOWER') }}</spam>
							</label>
							<div class="position-relative">
								<input type="number" step="0.01" class="form-control form-control-sm" v-model.number="voceSelezionata.UNIT_PRICE"
									placeholder="0.00"
									:disabled="voceSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1"
									@input="calcolaTotalePrezzo()"
									@blur="voceSelezionata.UNIT_PRICE = parseFloat(voceSelezionata.UNIT_PRICE || 0).toFixed(2)">
							</div>
						</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA'"></Translate></label>
							<select class="form-select form-select-sm" v-model="voceSelezionata.FK_ID_IVA_PREZZO">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in $root.arrayCodiciIva"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA'"></Translate> ({{ ivaModaleSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaModaleSommario.importo" disabled>
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.TOTALE_CON_IVA'"></Translate></label>
							<div class="position-relative">
								<input type="text" class="form-control form-control-sm bg-light text-primary fw-bold"
									:value="ivaModaleSommario.totale" readonly>
							</div>
						</div>
						<div class="col-6 col-md-auto">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.FEE'"></Translate> (%)</label>
							<div class="input-group input-group-sm">
								<input type="number" step="0.01" min="0" max="100"
									class="form-control form-control-sm"
									v-model.number="voceSelezionata.FEE"
									placeholder="0.00">
								<span class="input-group-text">%</span>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-danger mb-1 mt-2"><i class="ph-shopping-cart me-1"></i><Translate :path="'dizionario.attivita.ACQUISTO'"></Translate></h6>
					<div class="row mb-2">
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.QTA'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="voceSelezionata.QUANTITY_COST_ESPOSTO" placeholder="1"
								@input="calcolaTotaleCostoEsposto()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.RIP'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="voceSelezionata.DAYS_COST_ESPOSTO" placeholder="1"
								@input="calcolaTotaleCostoEsposto()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COSTO_ACQ'"></Translate>
								<spam
									class="badge badge-xs cursor-pointer float-end"
									:class="voceSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? 'bg-success' : 'bg-secondary'"
									@click="toggleOmaggio('UNIT_COST_ESPOSTO')"
									:title="voceSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? 'Clicca per disattivare omaggio' : 'Clicca per impostare come omaggio'"
								>{{ $root.translate('dizionario.attivita.OMAGGIO_LOWER') }}</spam>
							</label>
							<div class="position-relative">
								<input type="number" step="0.01" class="form-control form-control-sm"
									v-model.number="voceSelezionata.UNIT_COST_ESPOSTO" placeholder="0.00"
									:disabled="voceSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1"
									@input="calcolaTotaleCostoEsposto()"
									@blur="voceSelezionata.UNIT_COST_ESPOSTO = parseFloat(voceSelezionata.UNIT_COST_ESPOSTO || 0).toFixed(2)">
							</div>
						</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA_ACQUISTO'"></Translate></label>
							<select class="form-select form-select-sm" v-model="voceSelezionata.FK_ID_IVA_COSTO">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in $root.arrayCodiciIva"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA_ACQUISTO'"></Translate> ({{ ivaAcquistoSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaAcquistoSommario.importo" disabled>
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.TOTALE_ACQ_CON_IVA'"></Translate></label>
							<div class="position-relative">
								<input type="text" class="form-control form-control-sm bg-light text-danger fw-bold"
									:value="ivaAcquistoSommario.totale" readonly>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-warning mb-1 mt-2"><i class="ph-handshake me-1"></i><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></h6>
					<div class="row">
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA_COMMISSIONI'"></Translate></label>
							<select class="form-select form-select-sm" v-model="voceSelezionata.FK_ID_IVA_COMMISSIONI">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in $root.arrayCodiciIva"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></label>
							<div class="position-relative">
								<input type="number" step="0.01" class="form-control form-control-sm"
									v-model.number="voceSelezionata.TOTAL_COST_PRIVATO" placeholder="0.00"
									:disabled="voceSelezionata.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1"
									@blur="voceSelezionata.TOTAL_COST_PRIVATO = parseFloat(voceSelezionata.TOTAL_COST_PRIVATO || 0).toFixed(2)">
							</div>
						</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA_COMMISSIONI'"></Translate> ({{ ivaCommissioniSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaCommissioniSommario.importo" disabled>
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.TOTALE_COMM_CON_IVA'"></Translate></label>
							<input type="text" class="form-control form-control-sm bg-light text-warning fw-bold"
								:value="ivaCommissioniSommario.totale" disabled>
						</div>
					</div>
				</div>
				<div class="modal-footer py-2">
					<button type="button" class="btn btn-sm btn-link" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button type="button" class="btn btn-sm btn-secondary" @click="salvaVoce(false)"
						:disabled="!voceSelezionata.TITOLO_VOCE || !voceSelezionata.QUANTITY_PRICE">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CHIUDI'"></Translate>
					</button>
					<button v-if="voceSelezionata.ID_VOCE == 0" type="button" class="btn btn-sm btn-primary" @click="salvaVoce(true)"
						:disabled="!voceSelezionata.TITOLO_VOCE || !voceSelezionata.QUANTITY_PRICE">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CONTINUA'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div>


	<div class="modal fade" id="popUpStorico" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0 p-2">
					<h6 class="modal-title">
						<i class="ph-clock-counter-clockwise me-2"></i>
						<Translate :path="'dizionario.attivita.STORICO_REVISIONI'"></Translate> — <strong>{{ progetto.TITOLO }}</strong>
					</h6>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
						data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-2">
					<table class="table table-sm table-bordered mb-0">
						<thead>
							<tr class="bg-light">
								<th style="width:8%;">Rev.</th>
								<th style="width:22%;"><Translate :path="'dizionario.base.DATA'"></Translate></th>
								<th style="width:8%;"><Translate :path="'dizionario.attivita.REV_PADRE'"></Translate></th>
								<th><Translate :path="'dizionario.base.NOTE'"></Translate></th>
								<th style="width:12%;"><Translate :path="'dizionario.base.STATO'"></Translate></th>
								<th style="width:20%;" class="text-center"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="rev in paginatedListStorico.arr" :key="rev.ID_REVISIONE"
								:class="{ 'table-primary fw-semibold': revisioneVisualizzata && revisioneVisualizzata.ID_REVISIONE == rev.ID_REVISIONE }">
								<td class="text-center">{{ rev.PROGRESSIVO }}</td>
								<td>{{ rev.DATA_CREAZIONE }}</td>
								<td class="text-center">{{ rev.PROGRESSIVO_PADRE || '-' }}</td>
								<td>{{ rev.NOTE }}</td>
								<td class="text-center">
									<span v-if="rev.FLG_PUBBLICATA == 1" class="badge bg-secondary"><Translate :path="'dizionario.base.CONGELATA'"></Translate></span>
									<span v-else class="badge bg-success"><Translate :path="'dizionario.base.ATTIVA_F'"></Translate></span>
								</td>
								<td class="text-center">
									<a @click="visualizzaRevisione(rev); filters.closePopUp('popUpStorico')"
										class="btn btn-xs btn-primary btn-sm me-1 cursor-pointer">
										<i class="ph-eye"></i>
									</a>
									<a v-if="rev.FLG_PUBBLICATA == 1"
										@click="ripristinaRevisioneStorico(rev); filters.closePopUp('popUpStorico')"
										class="btn btn-xs btn-warning btn-sm cursor-pointer">
										<i class="ph-arrow-counter-clockwise"></i>
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer bg-light p-1">
					<div class="flex-grow-1">
						<Pagine v-model="searchStorico.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListStorico.count"
										:numpagine="searchStorico.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
					</div>
					<button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i>Chiudi
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- PopUp Aggiungi Voce Preferita -->
	<div class="modal fade" id="popUpAggiungiVocePreferita" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-md">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-secondary text-white">
					<h6 class="modal-title"><i class="ph-star me-2"></i>Aggiungi ai Preferiti</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<label class="form-label fw-semibold">Come vuoi salvare questa voce come preferita?</label>
						<p class="text-muted mb-0">
							<strong>Voce:</strong> {{ vocePreferitaTemp.TITOLO_VOCE }}
						</p>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button type="button" class="btn btn-secondary btn-sm" @click="salvaVocePreferitaSenzaAzienda()"
						:disabled="salvandoVocePreferita">
						<i class="ph-check me-1"></i>
						Senza Cliente
					</button>
					<button type="button" class="btn btn-secondary btn-sm" @click="salvaVocePreferitaConAzienda()"
						:disabled="salvandoVocePreferita">
						<i class="ph-check me-1"></i>
						Con Cliente
					</button>
					<button type="button" class="btn btn-secondary btn-sm" @click="salvaVocePreferitaDueVersioni()"
						:disabled="salvandoVocePreferita">
						<i class="ph-check me-1"></i>
						Entrambe
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modale Importa Voce Preferita -->
	<div class="modal fade" id="popUpImportaVocePreferita" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-info text-white">
					<h6 class="modal-title"><i class="fa fa-star me-2"></i>Importa Voce Preferita in "{{ attivitaPerAzioni?.TITOLO }}"</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<input type="text" class="form-control mb-2" placeholder="Cerca..."
						v-model="searchVocePreferitaImport.TITOLO.VALUE">

					<div v-if="vociPreferiteSelezionate.length > 0" class="alert alert-info py-1 mb-2">
						{{ vociPreferiteSelezionate.length }} voc{{ vociPreferiteSelezionate.length == 1 ? 'e' : 'i' }} selezionat{{ vociPreferiteSelezionate.length == 1 ? 'a' : 'e' }}
					</div>

					<div style="height: 400px; overflow-y: auto;">
						<table class="table table-bordered table-hover table-striped text-nowrap">
							<thead class="sticky-top thead-bordered">
								<tr class="bg-secondary text-white">
									<th class="table-head-sm text-center" style="width:3%;" rowspan="2">
										<input type="checkbox" v-model="selectAllVociImport" @change="toggleSelectAllVociImport">
									</th>
									<th class="table-head-sm text-center" style="width:3%;" rowspan="2">#</th>
									<th class="table-head-sm text-center bg-secondary bg-opacity-75" style="width:55%;" colspan="6">VENDITA</th>
									<th class="table-head-sm text-center bg-secondary bg-opacity-75 text-yellow" style="width:29%;" colspan="4">ACQUISTO</th>
								</tr>
								<tr class="bg-secondary text-white">
									<th class="table-head-sm" style="width:18%;">Titolo</th>
									<th class="table-head-sm text-center" style="width:6%;">Q.tà</th>
									<th class="table-head-sm text-center" style="width:6%;">Rip.</th>
									<th class="table-head-sm text-end" style="width:8%;">Prezzo Unit.</th>
									<th class="table-head-sm text-end" style="width:9%;">Totale</th>
									<th class="table-head-sm" style="width:8%;">Cliente</th>
									<th class="table-head-sm text-end text-yellow" style="width:8%;">Costo Unit.</th>
									<th class="table-head-sm text-end text-yellow" style="width:9%;">Costi</th>
									<th class="table-head-sm text-end text-yellow" style="width:9%;">Commissioni</th>
									<th class="table-head-sm text-yellow" style="width:10%;">Fornitore</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(vp, index) in paginatedVociPreferiteImport.arr" :key="vp.ID_VOCE_PREFERITA"
									@click="toggleVocePreferitaImport(vp.ID_VOCE_PREFERITA)" style="cursor: pointer;">
									<td class="table-head-sm text-center">
										<input type="checkbox" :checked="vociPreferiteSelezionate.includes(vp.ID_VOCE_PREFERITA)" @click.stop @change="toggleVocePreferitaImport(vp.ID_VOCE_PREFERITA)">
									</td>
									<td class="table-head-sm text-center"><small>{{ index + 1 }}</small></td>
									<td class="table-head-sm" style="word-wrap: break-word; white-space: normal;">
										<i class="ph-file-text me-1 text-muted"></i><strong>{{ vp.TITOLO }}</strong>
										<div v-if="vp.TESTO_NOTE" class="text-muted small">{{ vp.TESTO_NOTE }}</div>
									</td>
									<td class="table-head-sm text-end">{{ parseFloat(vp.QUANTITY_PRICE) }}</td>
									<td class="table-head-sm text-end">{{ parseFloat(vp.DAYS_PRICE) }}</td>
									<td class="table-head-sm text-end"><span class="text-muted" style="font-size:0.75rem;">&euro; {{ vp.UNIT_PRICE }}</span></td>
									<td class="table-head-sm text-end">
										<span class="text-primary fw-semibold">&euro; {{ vp.TOTAL_PRICE }}</span>
										<span v-if="getIvaCode(vp.FK_ID_IVA_PREZZO)"
											class="badge bg-secondary ms-1"
											style="font-size:0.65rem;"
											:title="getIvaCode(vp.FK_ID_IVA_PREZZO).DESCRIZIONE">
											{{ getIvaCode(vp.FK_ID_IVA_PREZZO).CUSTOM_1 }}
										</span>
									</td>
									<td class="table-head-sm">
										<span v-if="vp.AZIENDA" class="text-muted" style="font-size:0.75rem;">{{ filters.accorciaTesto(vp.AZIENDA, 30) }}</span>
										<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
									</td>
									<td class="table-head-sm text-end"><span class="text-muted" style="font-size:0.75rem;">&euro; {{ vp.UNIT_COST_ESPOSTO }}</span></td>
									<td class="table-head-sm text-end">
										<span class="text-danger fw-semibold">&euro; {{ vp.TOTAL_COST_ESPOSTO }}</span>
										<span v-if="getIvaCode(vp.FK_ID_IVA_COSTO)"
											class="badge bg-secondary ms-1"
											style="font-size:0.65rem;"
											:title="getIvaCode(vp.FK_ID_IVA_COSTO).DESCRIZIONE">
											{{ getIvaCode(vp.FK_ID_IVA_COSTO).CUSTOM_1 }}
										</span>
									</td>
									<td class="table-head-sm text-end">
										<span class="text-warning" style="font-size:0.75rem;">&euro; {{ parseFloat(vp.UNIT_COST_PRIVATO).toFixed(2) }}</span>
										<span v-if="getIvaCode(vp.FK_ID_IVA_COMMISSIONI)"
											class="badge bg-secondary ms-1"
											style="font-size:0.65rem;"
											:title="getIvaCode(vp.FK_ID_IVA_COMMISSIONI).DESCRIZIONE">
											{{ getIvaCode(vp.FK_ID_IVA_COMMISSIONI).CUSTOM_1 }}
										</span>
									</td>
									<td class="table-head-sm">
										<span v-if="vp.AZIENDA_FORNITORE" class="text-muted" style="font-size:0.75rem;">{{ filters.accorciaTesto(vp.AZIENDA_FORNITORE, 30) }}</span>
										<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
									</td>
								</tr>
								<tr v-if="paginatedVociPreferiteImport.arr?.length == 0">
									<td colspan="12" class="text-center text-muted">Nessuna voce preferita trovata</td>
								</tr>
							</tbody>
						</table>
					</div>

					<Pagine :search="searchVocePreferitaImport" :modalita="$root.isMobile ? 2 : 1" />
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button type="button" class="btn btn-primary btn-sm"
						:disabled="vociPreferiteSelezionate.length == 0"
						@click="eseguiImportaVocePreferita()">
						<i class="fa fa-plus me-1"></i>Importa {{ vociPreferiteSelezionate.length > 0 ? `(${vociPreferiteSelezionate.length})` : '' }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modale Import Excel Offline -->
	<ImportAttivitaExcel
		v-if="showImportAttivitaExcel"
		:idProgetto="progetto.ID_PROGETTO"
		:idRevisione="revisioneCorrente.ID_REVISIONE"
		@imported="getAttivita(); showImportAttivitaExcel = false"
		@close="showImportAttivitaExcel = false"
	/>

	<!-- Modale Modalità Esportazione Excel -->
	<div class="modal fade" id="popUpModalitaEsportazione" role="dialog" tabindex="-1" data-bs-backdrop="static">
		<div class="modal-dialog modal-md" role="document">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-success text-white">
					<h6 class="modal-title">
						<i class="far fa-file-excel me-2"></i>Seleziona Modalità Esportazione
					</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<label class="form-label fw-semibold">In che modalità vuoi esportarla?</label>
						<select class="form-select" v-model="modalitaEsportazioneSelezionata">
							<option value="">Seleziona una modalità...</option>
							<option v-for="opzione in arrayModalitaEsportazione" :key="opzione.ID_OPZIONE_TIPOLOGICA"
								:value="opzione.ICONA">
								{{ opzione.DESCRIZIONE }}
							</option>
						</select>
					</div>

					<!-- Spiegazioni modalità -->
					<div v-if="modalitaEsportazioneSelezionata == 1005" class="alert alert-info mb-0 mx-3">
						<div class="fw-semibold mb-1">
							<i class="far fa-info-circle me-1"></i>Modalità MISTA
						</div>
						<div class="small">
							Le <strong>attività principali</strong> (stesso livello) verranno esportate su <strong>fogli separati</strong>.
							Assicurati che le attività principali siano tutte allo stesso livello gerarchico.
						</div>
					</div>

					<div v-if="modalitaEsportazioneSelezionata == 1007" class="alert alert-info mb-0 mx-3">
						<div class="fw-semibold mb-1">
							<i class="far fa-info-circle me-1"></i>Modalità UNICA
						</div>
						<div class="small">
							Tutte le attività verranno esportate in un <strong>unico foglio</strong>.
							<br>Se vuoi che il foglio porti il nome del progetto, crea un'attività principale che racchiuda tutte le altre.
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-times me-1"></i> Annulla
					</button>
					<button type="button" class="btn btn-success" @click="confermaEsportazioneExcel()">
						<i class="far fa-file-excel me-1"></i> Esporta
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal: Scelta tipo creazione attività -->
	<div class="modal fade" id="popUpSceltaTipoCreazione" tabindex="-1" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-md" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Aggiungi Attività</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="row g-3">
						<!-- Card 1: Crea Attività -->
						<div class="col-6">
							<div class="card h-100 cursor-pointer border-primary text-center p-4"
								 @click="filters.closePopUp('popUpSceltaTipoCreazione'); creaAttivita({})">
								<i class="ph-plus-circle fs-1 text-primary mb-2"></i>
								<h6>Crea Attività</h6>
							</div>
						</div>
						<!-- Card 2: Importa da altro progetto -->
						<div class="col-6">
							<div class="card h-100 cursor-pointer border-success text-center p-4"
								 @click="apriImportaAttivita()">
								<i class="ph-copy fs-1 text-success mb-2"></i>
								<h6>Importa attività e voci da un altro progetto</h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal: Importa attività da altro progetto -->
	<div class="modal fade" id="popUpImportaAttivita" tabindex="-1" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">Importa Attività da Altro Progetto</h5>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<!-- Select progetto -->
					<div class="mb-3">
						<label class="form-label">Seleziona Progetto</label>
						<select class="form-select" v-model="progettoSelezionatoPerImport"
								@change="onProgettoImportChange()">
							<option :value="null" disabled>-- Scegli un progetto --</option>
							<option v-for="p in progettiPerImport" :key="p.ID_PROGETTO"
									:value="p.ID_PROGETTO">{{ p.TITOLO }} ({{ p.CODICE }})</option>
						</select>
					</div>

					<div v-if="revisioniPerImport.length > 0" class="mb-3 d-flex flex-wrap gap-1">
						<button v-for="rev in revisioniPerImport" :key="rev.ID_REVISIONE"
							class="btn btn-sm"
							:class="rev.ID_REVISIONE == revisioneSelezionataPerImport ? 'btn-primary' : 'btn-outline-secondary'"
							@click="onRevisioneImportChange(rev.ID_REVISIONE)">
							Rev. {{ rev.PROGRESSIVO }}
							<span v-if="basketCountsByRevision[rev.ID_REVISIONE] > 0" class="badge bg-warning text-dark ms-1">
								{{ basketCountsByRevision[rev.ID_REVISIONE] }}
							</span>
						</button>
					</div>

					<div v-if="attivitaSelezionatePerImport.length > 0" class="alert alert-info py-1 mb-2">
						{{ attivitaSelezionatePerImport.length }} attività selezionate per l'importazione
					</div>

					<div v-if="loadingImport" class="text-center py-4">
						<div class="spinner-border text-primary" role="status"></div>
					</div>

					<div v-else-if="attivitaPerImport.length > 0">
						<div class="mb-2 d-flex align-items-center gap-2">
							<input type="checkbox" id="chkAllAttivitaImport"
								v-model="selectAllAttivitaImport"
								@change="toggleSelectAllAttivitaImport">
							<label for="chkAllAttivitaImport" class="mb-0">Seleziona tutti</label>
						</div>
						<TabAttivitaImport
							v-for="attivita in attivitaPerImport"
							:key="attivita.ID_ATTIVITA"
							:attivita="attivita"
							:filters="filters"
							:selezionati="idAttivitaSelezionateCorrente"
							@toggleSelezionato="toggleAttivitaSelezionataPerImport($event)" />
					</div>

					<div v-else-if="progettoSelezionatoPerImport" class="text-muted text-center py-3">
						Nessuna attività trovata in questo progetto.
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
					<button class="btn btn-primary btn-sm"
						:disabled="attivitaSelezionatePerImport.length == 0"
						@click="importaAttivitaSelezionate()">
						<i class="ph-copy me-1"></i>
						Importa{{ attivitaSelezionatePerImport.length > 0 ? ` (${attivitaSelezionatePerImport.length})` : '' }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<SchedaAzienda ref="schedaAziendaFornitore" :tipo="2" @aziendaSalvata="onFornitoreCreato"></SchedaAzienda>

	<ModalNuovaRevisione
		ref="modalNuovaRevisione"
		:fk-id-progetto="progetto.ID_PROGETTO"
		:progressivo-corrente="revisioneCorrente ? revisioneCorrente.PROGRESSIVO : 0"
		@revisione-creata="onRevisioneCreata()"
	/>

	<ModalNuovaSpesa
		v-if="showModalNuovaSpesa"
		:defaultIdProgetto="progetto.ID_PROGETTO"
		:notaSpesa="notaSpesaInEdit"
		@close="showModalNuovaSpesa = false; notaSpesaInEdit = null"
		@saved="showModalNuovaSpesa = false; notaSpesaInEdit = null; getNoteSpese()"
	/>
</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import AttivitaNode from '@/components/AttivitaNode.vue'
import Select2 from '@/components/utils/Select2.vue'
import SchedaAzienda from '@/components/SchedaAzienda.vue'
import TabAttivitaImport from '@/components/utils/TabAttivitaImport.vue'
import ModalNuovaRevisione from '@/components/ModalNuovaRevisione.vue'
import NoteSpeseProg from '@/components/NoteSpeseProg.vue'
import ModalNuovaSpesa from '@/components/ModalNuovaSpesa.vue'
import { VueDraggableNext } from 'vue-draggable-next'
import ImportAttivitaExcel from '@/components/ImportAttivitaExcel.vue'


export default {
	name: 'Attivita',

	components: {
		Pagine,
		ISwitch,
		AttivitaNode,
		Select2,
		SchedaAzienda,
		TabAttivitaImport,
		ModalNuovaRevisione,
		NoteSpeseProg,
		ModalNuovaSpesa,
		draggable: VueDraggableNext,
		ImportAttivitaExcel,
	},

	data: function () {
		return {
			filters: global.filters,
			GLOBAL_IMAGES_PATH: '',
			anno: new Date().getFullYear(),
			arrayAttivita: new Array(),
			attivitaSelezionata: {},
			draggingRootAttivita: null,
			search: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				ID_ATTIVITA: { TYPE: 'TEXT', VALUE: '' },
				ID_VOCE: { TYPE: 'TEXT', VALUE: '' },
				FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '1' },
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				TITOLO_VOCE: { TYPE: 'TEXT', VALUE: '' },
				FLG_DA_CALCOLARE: { TYPE: 'COMBO', VALUE: '' },
				FLG_ELIMINATO: { TYPE: 'COMBO', VALUE: '0' },
			},

			voceSelezionata: {},
			attivitaPerVoce: {},
			attivitaPerAzioni: {},
			vocePerAzioni: {},
			attivitaPerAzioniVoce: {},
			progetto: {},
			ordinamento: '',
			revisioni: [],
			revisioneCorrente: null,
			revisioneVisualizzata: null,
			revisionePerRipristino: null,
			noteRipristinaRevisione: '',
			allExpanded: true,
			vocePreferitaTemp: {},
			salvandoVocePreferita: false,
			hasUnsavedChanges: false,
			saving: false,
			editMode: false,
			searchStorico: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				ID_ATTIVITA: { TYPE: 'TEXT', VALUE: '' },
				ID_VOCE: { TYPE: 'TEXT', VALUE: '' },
				FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '1' },
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				TITOLO_VOCE: { TYPE: 'TEXT', VALUE: '' },
				FLG_DA_CALCOLARE: { TYPE: 'COMBO', VALUE: '' },
			},

			// Modalità esportazione Excel
			arrayModalitaEsportazione: new Array(),
			modalitaEsportazioneSelezionata: null,

			showImportAttivitaExcel: false,

			// Toggle per visualizzare percentuale del margine
			showMarginePercentage: false,
			// Toggle per mostrare valori IVA inclusa
			showIva: false,

			omaggioBackup: {},

			// Dati per import da altro progetto
			progettiPerImport: [],
			progettoSelezionatoPerImport: null,
			attivitaPerImport: [],
			loadingImport: false,
			revisioniPerImport: [],
			revisioneSelezionataPerImport: null,
			attivitaSelezionatePerImport: [],

			// Dati per importa voce preferita
			vociPreferitePerImport: [],
			vociPreferiteSelezionate: [],
			selectAllVociImport: false,
			searchVocePreferitaImport: {
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 }
			},

			// Note Spese
			arrayNoteSpese: [],
			showModalNuovaSpesa: false,
			notaSpesaInEdit: null,
		}

	},

	methods: {
		getPct(value) {
			const budget = parseFloat(this.getTotali.BUDGET) || 0;
			if (budget == 0) return '';
			return ((parseFloat(value) || 0) / budget * 100).toFixed(1) + '% del budget';
		},

		getNoteSpese() {
			if (!this.progetto || !this.progetto.ID_PROGETTO) return;
			utils.ajax('theb/notespese/progetto', { FK_ID_PROGETTO: this.progetto.ID_PROGETTO}, (response) => {
				if (response.esito == 0) {
					this.arrayNoteSpese = response.data;
				}
			});
		},

		/**
		 * Calcola la percentuale del margine rispetto al budget
		 */
		getMarginePercentage: function () {
			const budget = parseFloat(this.getTotali.BUDGET) || 0;
			const margine = parseFloat(this.getTotali.MARGINE) || 0;
			if (budget == 0) return 0;
			return ((margine / budget) * 100).toFixed(2);
		},

		/**
		 * Toggle visualizzazione percentuale margine
		 */
		toggleMarginePercentage: function () {
			this.showMarginePercentage = !this.showMarginePercentage;
		},

		getAttivita(idRevisione = null) {
			this.progetto = utils.clone(this.$root.progetto);
			const payload = {
				FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
				IS_GOD: this.$root.isGod ? 1 : 0
			};
			if (idRevisione !== null) payload.FK_ID_REVISIONE = idRevisione;
			utils.ajax("theb/attivita", payload, (response) => {
				this.arrayAttivita = response.data || [];
			});
		},

		caricaRevisioni() {
			utils.ajax('theb/revisioni', { FK_ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
				if (response.esito == 0) {
					this.revisioni = response.data || [];
					this.revisioneCorrente = this.revisioni[this.revisioni.length - 1] || null;
					this.revisioneVisualizzata = this.revisioneCorrente;
				}
			});
		},

		visualizzaRevisione(revisione) {
			this.revisioneVisualizzata = revisione;
			this.getAttivita(revisione.ID_REVISIONE);
		},

		creaRevisione() {
			this.$refs.modalNuovaRevisione.apri();
		},

		onRevisioneCreata() {
			this.caricaRevisioni();
			this.getAttivita();
		},

		ripristinaRevisioneStorico(revisione) {
			utils.alert.confirm('Vuoi ripristinare la Revisione ' + revisione.PROGRESSIVO + '?', () => {
				setTimeout(() => {
					utils.alert.confirm('Verrà creata una nuova revisione che è copia della Rev. ' + revisione.PROGRESSIVO + '. Confermi?', () => {
						utils.ajax('theb/revisione/ripristina', {
							FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
							PROGRESSIVO: revisione.PROGRESSIVO,
							ID_REVISIONE: revisione.ID_REVISIONE,
						}, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Revisione ripristinata!');
								this.caricaRevisioni();
								this.getAttivita();
							}
						});
					}, this.$root);
				}, 400);
			}, this.$root);
		},

		flattenAttivita(nodi, risultato) {
			for (var i = 0; i < nodi.length; i++) {
				risultato.push(nodi[i]);
				if (nodi[i].SOTTO_ATTIVITA && nodi[i].SOTTO_ATTIVITA.length > 0) {
					this.flattenAttivita(nodi[i].SOTTO_ATTIVITA, risultato);
				}
			}
		},

		toggleAllAttivita() {
			const chk = document.getElementById('chkAllAttivita');
			this.allExpanded = chk.checked;
		},

		apriSceltaTipoCreazione() {
			this.filters.openPopUp('popUpSceltaTipoCreazione');
		},

		apriImportaAttivita() {
			this.filters.closePopUp('popUpSceltaTipoCreazione');
			this.progettoSelezionatoPerImport = null;
			this.attivitaPerImport = [];
			this.revisioniPerImport = [];
			this.revisioneSelezionataPerImport = null;
			this.attivitaSelezionatePerImport = [];
			this.selectAllAttivitaImport = false;
			utils.ajax("theb/progetti", {}, (response) => {
				this.progettiPerImport = (response.data || []).filter(
					p => p.ID_PROGETTO !== this.progetto.ID_PROGETTO
				);
			});
			this.filters.openPopUp('popUpImportaAttivita');
		},


		onProgettoImportChange() {
			if (!this.progettoSelezionatoPerImport) return;
			this.loadingImport = true;
			this.revisioniPerImport = [];
			this.revisioneSelezionataPerImport = null;
			this.attivitaPerImport = [];
			utils.ajax('theb/revisioni', { FK_ID_PROGETTO: this.progettoSelezionatoPerImport }, (response) => {
				this.revisioniPerImport = response.data || [];
				const lastRev = this.revisioniPerImport[this.revisioniPerImport.length - 1];
				if (lastRev) {
					this.revisioneSelezionataPerImport = lastRev.ID_REVISIONE;
					this.caricaAttivitaPerImport(lastRev.ID_REVISIONE);
				} else {
					this.loadingImport = false;
				}
			});
		},

		prepareAttivitaImport(attivita) {
			return {
				...attivita,
				VOCI: attivita.VOCI || [],
				SOTTO_ATTIVITA: (attivita.SOTTO_ATTIVITA || []).map(s => this.prepareAttivitaImport(s)),
			};
		},

		importaAttivitaSelezionate() {
			if (!this.attivitaSelezionatePerImport.length) return;
			this.loadingImport = true;
			const items = [...this.attivitaSelezionatePerImport];
			const requests = items.map(item => new Promise((resolve) => {
				utils.ajax('theb/attivita/copia-albero', {
					ID_ATTIVITA_ORIGINE: item.ID_ATTIVITA,
					ID_PROGETTO_DESTINAZIONE: this.progetto.ID_PROGETTO,
				}, () => resolve());
			}));
			Promise.all(requests).then(() => {
				this.filters.closePopUp('popUpImportaAttivita');
				this.getAttivita();
			});
		},

		caricaAttivitaPerImport(idRevisione) {
			this.loadingImport = true;
			utils.ajax('theb/attivita', {
				FK_ID_PROGETTO: this.progettoSelezionatoPerImport,
				FK_ID_REVISIONE: idRevisione,
			}, (response) => {
				this.attivitaPerImport = (response.data || []).map(a => this.prepareAttivitaImport(a));
				this.loadingImport = false;
			});
		},

		onRevisioneImportChange(idRevisione) {
			this.revisioneSelezionataPerImport = idRevisione;
			this.selectAllAttivitaImport = false;
			this.caricaAttivitaPerImport(idRevisione);
		},

		toggleAttivitaSelezionataPerImport(attivita) {
			const idx = this.attivitaSelezionatePerImport.findIndex(
				a => a.ID_ATTIVITA == attivita.ID_ATTIVITA && a.ID_REVISIONE == this.revisioneSelezionataPerImport
			);
			if (idx >= 0) {
				this.attivitaSelezionatePerImport.splice(idx, 1);
			} else {
				const rev = this.revisioniPerImport.find(r => r.ID_REVISIONE == this.revisioneSelezionataPerImport);
				this.attivitaSelezionatePerImport.push({
					ID_ATTIVITA: attivita.ID_ATTIVITA,
					TITOLO: attivita.TITOLO,
					ID_REVISIONE: this.revisioneSelezionataPerImport,
					PROGRESSIVO: rev?.PROGRESSIVO,
				});
			}
		},

		toggleSelectAllAttivitaImport() {
			if (!this.selectAllAttivitaImport) {
				this.attivitaSelezionatePerImport = this.attivitaSelezionatePerImport
					.filter(a => a.ID_REVISIONE != this.revisioneSelezionataPerImport);
				return;
			}
			const rev = this.revisioniPerImport.find(r => r.ID_REVISIONE == this.revisioneSelezionataPerImport);
			const notYetSelected = this.attivitaPerImport.filter(
				a => !this.idAttivitaSelezionateCorrente.includes(a.ID_ATTIVITA)
			);
			this.attivitaSelezionatePerImport.push(...notYetSelected.map(a => ({
				ID_ATTIVITA: a.ID_ATTIVITA,
				TITOLO: a.TITOLO,
				ID_REVISIONE: this.revisioneSelezionataPerImport,
				PROGRESSIVO: rev?.PROGRESSIVO,
			})));
		},

		apriImportaVocePreferita(attivita) {
			this.attivitaPerAzioni = attivita;
			this.vociPreferiteSelezionate = [];
			this.searchVocePreferitaImport.TITOLO.VALUE = '';
			this.searchVocePreferitaImport.PAGINATION.PAGE_NUMBER = 1;

			utils.ajax('theb/vocipreferite', {}, (response) => {
				this.vociPreferitePerImport = response.data || [];
				this.searchVocePreferitaImport.PAGINATION.LENGTH = this.vociPreferitePerImport.length;
				this.filters.openPopUp('popUpImportaVocePreferita');
			});
		},

		toggleVocePreferitaImport(id) {
			const index = this.vociPreferiteSelezionate.indexOf(id);
			if (index > -1) {
				this.vociPreferiteSelezionate.splice(index, 1);
			} else {
				this.vociPreferiteSelezionate.push(id);
			}
			this.selectAllVociImport = this.paginatedVociPreferiteImport.arr.every(vp => this.vociPreferiteSelezionate.includes(vp.ID_VOCE_PREFERITA));
		},

		toggleSelectAllVociImport() {
			if (this.selectAllVociImport) {
				this.vociPreferiteSelezionate = this.paginatedVociPreferiteImport.arr.map(vp => vp.ID_VOCE_PREFERITA);
			} else {
				this.vociPreferiteSelezionate = [];
			}
		},

		eseguiImportaVocePreferita() {
			if (this.vociPreferiteSelezionate.length == 0) {
				utils.alert.warning('Seleziona almeno una voce preferita');
				return;
			}

			const payload = {
				IDS: this.vociPreferiteSelezionate,
				ID_PROGETTO: this.progetto.ID_PROGETTO,
				ID_ATTIVITA: this.attivitaPerAzioni.ID_ATTIVITA
			};

			utils.ajax('theb/vocepreferita/importa', payload, (response) => {
				if (response.esito == 0) {
					utils.alert.success(response.messaggio || 'Voci preferite importate con successo!');
					this.vociPreferiteSelezionate = [];
					this.filters.closePopUp('popUpImportaVocePreferita');
					this.getAttivita();
				} else {
					utils.alert.danger(response.messaggio || 'Errore durante l\'importazione');
				}
			});
		},

		getIvaCode(fkId) {
			return (this.$root.arrayCodiciIva || []).find(c => c.ID_OPZIONE_TIPOLOGICA == fkId) || null;
		},

		creaAttivita(opzioni) {
			this.attivitaSelezionata = {
				ID_ATTIVITA: 0,
				FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
				FK_ID_ATTIVITA: (opzioni && opzioni.FK_ID_ATTIVITA) ? opzioni.FK_ID_ATTIVITA : null,
				TITOLO: '',
				DESCRIZIONE: '',
				COLORE: '#A5A5A5',
				FLG_DA_CALCOLARE: 1,
			};
			this.filters.openPopUp('popUpAttivita');
		},

		modificaAttivita(attivita) {
			this.attivitaSelezionata = utils.clone(attivita);
			this.filters.openPopUp('popUpAttivita');
		},

		salvaAttivita(continua) {
			const api = this.attivitaSelezionata.ID_ATTIVITA > 0 ? "theb/attivita/update" : "theb/attivita/insert";
			utils.ajax(api, this.attivitaSelezionata, (response) => {
				if (response.esito == 0) {
					const msg = this.attivitaSelezionata.ID_ATTIVITA > 0 ? "aggiornata" : "creata";
					utils.alert.success(`Attività ${msg} con successo.`);
					utils.notifiche.invia(this, this.attivitaSelezionata.ID_ATTIVITA > 0 ? 'ATTIVITA_MODIFICA' : 'ATTIVITA_CREA', (this.attivitaSelezionata.ID_ATTIVITA > 0 ? 'ha modificato l\'attività "' : 'ha creato una nuova attività "') + this.attivitaSelezionata.TITOLO + '"');
					this.getAttivita();
					if (continua) {
						this.attivitaSelezionata = {
							ID_ATTIVITA: 0,
							FK_ID_PROGETTO: this.attivitaSelezionata.FK_ID_PROGETTO,
							FK_ID_ATTIVITA: this.attivitaSelezionata.FK_ID_ATTIVITA,
							TITOLO: '',
							DESCRIZIONE: '',
							COLORE: '#A5A5A5',
							FLG_DA_CALCOLARE: 1,
						};
					} else {
						this.filters.closePopUp("popUpAttivita");
					}
				}
			});
		},

		creaVoce(attivita) {
			this.attivitaPerVoce = attivita;
			this.voceSelezionata = {
				FK_ID_ATTIVITA: attivita.ID_ATTIVITA,
				FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
				ID_VOCE: 0,
				TITOLO_VOCE: '',
				NOTE: '',
				FK_ID_AZIENDA: this.progetto.FK_ID_AZIENDA || null,
				FK_ID_AZIENDA_FORNITORE: null,
				QUANTITY_PRICE: 1,
				DAYS_PRICE: 1,
				QUANTITY_COST_ESPOSTO: 1,
				DAYS_COST_ESPOSTO: 1,
				UNIT_PRICE: 0,
				TOTAL_PRICE: 0,
				FK_ID_IVA_PREZZO: null,
				UNIT_COST_ESPOSTO: 0,
				TOTAL_COST_ESPOSTO: 0,
				FK_ID_IVA_COSTO: null,
				UNIT_COST_PRIVATO: 0,
				TOTAL_COST_PRIVATO: 0,
				FK_ID_IVA_COMMISSIONI: null,
				FLG_DA_CALCOLARE: 1,
				FLG_OMAGGIO_UNIT_PRICE: 0,
				FLG_OMAGGIO_TOTAL_PRICE: 0,
				FLG_OMAGGIO_UNIT_COST_ESPOSTO: 0,
				FLG_OMAGGIO_UNIT_COST_PRIVATO: 0,
				FLG_OMAGGIO_TOTAL_COST_PRIVATO: 0,
				FEE: 0,
			};
			this.filters.openPopUp("popUpVoce");
		},

		modificaVoce(voce, attivita) {
			this.attivitaPerVoce = attivita || {};
			this.voceSelezionata = utils.clone(voce);
			this.filters.openPopUp('popUpVoce');
		},

		calcolaTotalePrezzo() {
			// Forza quantità e ripetizioni a valori interi
			const quantity = parseInt(this.voceSelezionata.QUANTITY_PRICE) || 0;
			const days = parseInt(this.voceSelezionata.DAYS_PRICE) || 1;
			const unitPrice = parseFloat(this.voceSelezionata.UNIT_PRICE) || 0;

			// Aggiorna i valori nel modello per rimuovere eventuali decimali
			this.voceSelezionata.QUANTITY_PRICE = quantity;
			this.voceSelezionata.DAYS_PRICE = days;

			this.voceSelezionata.TOTAL_PRICE = (unitPrice * quantity * days).toFixed(2);
		},

		calcolaTotaleCostoEsposto() {
			// Forza quantità e ripetizioni a valori interi
			const quantity = parseInt(this.voceSelezionata.QUANTITY_COST_ESPOSTO) || 0;
			const days = parseInt(this.voceSelezionata.DAYS_COST_ESPOSTO) || 1;
			const unitCostEsposto = parseFloat(this.voceSelezionata.UNIT_COST_ESPOSTO) || 0;

			// Aggiorna i valori nel modello per rimuovere eventuali decimali
			this.voceSelezionata.QUANTITY_COST_ESPOSTO = quantity;
			this.voceSelezionata.DAYS_COST_ESPOSTO = days;

			this.voceSelezionata.TOTAL_COST_ESPOSTO = (unitCostEsposto * quantity * days).toFixed(2);
		},

		toggleOmaggio(field) {
			const flagField = `FLG_OMAGGIO_${field}`;
			const isOmaggio = this.voceSelezionata[flagField] == 1;
			this.voceSelezionata[flagField] = isOmaggio ? 0 : 1;

			if (!isOmaggio) {
				this.omaggioBackup[field] = this.voceSelezionata[field];
				this.voceSelezionata[field] = 0;
			} else {
				this.voceSelezionata[field] = this.omaggioBackup[field] ?? 0;
			}
			if (field == 'UNIT_COST_ESPOSTO') {
				this.calcolaTotaleCostoEsposto();
			} else if (field == 'UNIT_PRICE') {
				this.calcolaTotalePrezzo();
			}
		},

		calcolaTotaleCostoPrivato() {
			// Le commissioni vengono inserite manualmente dall'utente
			// Non c'è un calcolo automatico con quantità/ripetizioni
			const unitCostPrivato = parseFloat(this.voceSelezionata.UNIT_COST_PRIVATO) || 0;
			if (!this.voceSelezionata.TOTAL_COST_PRIVATO || this.voceSelezionata.TOTAL_COST_PRIVATO == 0) {
				this.voceSelezionata.TOTAL_COST_PRIVATO = unitCostPrivato.toFixed(2);
			}
		},

		parseCodiceIva(codiceIva) {
			if (!codiceIva) return { aliquota: 0, tipo: 'nessuna', onHalf: false };
			const custom1 = codiceIva.CUSTOM_1 || '';
			const aliquota = parseFloat(codiceIva.ICONA) || 0;
			const onHalf = custom1.startsWith('i50');
			let tipo = 'nessuna';
			if (aliquota > 0) {
				tipo = (custom1.endsWith('i') || custom1 == 'IN') ? 'inclusa'
					 : custom1.endsWith('e') ? 'esclusa'
					 : 'nessuna';
			}
			return { aliquota, tipo, onHalf };
		},

		calcolaImportoIva(prezzo, codiceIva) {
			const { aliquota, tipo, onHalf } = this.parseCodiceIva(codiceIva);
			const p = parseFloat(prezzo) || 0;
			if (tipo == 'nessuna') return 0;
			const base = onHalf ? p / 2 : p;
			const rate = aliquota / 100;
			return tipo == 'esclusa'
				? base * rate
				: base - base / (1 + rate);
		},

		salvaVoce(continua = false) {
			this.salvandoVoce = true;

			// Validazione: titolo obbligatorio
			if (!this.voceSelezionata.TITOLO_VOCE || this.voceSelezionata.TITOLO_VOCE.trim() == '') {
				utils.alert.warning("Il titolo della voce è obbligatorio");
				this.salvandoVoce = false;
				return;
			}

			// Validazione: quantità e ripetizioni devono essere almeno 1
			if (!this.voceSelezionata.QUANTITY_PRICE || this.voceSelezionata.QUANTITY_PRICE < 1) {
				utils.alert.warning("La quantità (Prezzo) deve essere almeno 1");
				this.salvandoVoce = false;
				return;
			}
			if (!this.voceSelezionata.DAYS_PRICE || this.voceSelezionata.DAYS_PRICE < 1) {
				utils.alert.warning("Le ripetizioni (Prezzo) devono essere almeno 1");
				this.salvandoVoce = false;
				return;
			}
			if (!this.voceSelezionata.QUANTITY_COST_ESPOSTO || this.voceSelezionata.QUANTITY_COST_ESPOSTO < 1) {
				utils.alert.warning("La quantità (Costo Esposto) deve essere almeno 1");
				this.salvandoVoce = false;
				return;
			}
			if (!this.voceSelezionata.DAYS_COST_ESPOSTO || this.voceSelezionata.DAYS_COST_ESPOSTO < 1) {
				utils.alert.warning("Le ripetizioni (Costo Esposto) devono essere almeno 1");
				this.salvandoVoce = false;
				return;
			}

			this.calcolaTotalePrezzo();
			this.calcolaTotaleCostoEsposto();
			this.calcolaTotaleCostoPrivato();

			var api = this.voceSelezionata.ID_VOCE > 0 ? "theb/voce/update" : "theb/voce/insert";

			const payload = { ...this.voceSelezionata };
			if (payload.TITOLO_VOCE) {
				payload.TITOLO = payload.TITOLO_VOCE;
			}

			utils.ajax(api, payload, (response) => {
				this.salvandoVoce = false;
				if (response.esito == 0) {
					const msg = this.voceSelezionata.ID_VOCE > 0 ? "aggiornata" : "creata";
					utils.alert.success(`Voce ${msg} con successo.`);
					utils.notifiche.invia(this, this.voceSelezionata.ID_VOCE > 0 ? 'VOCE_MODIFICA' : 'VOCE_CREA', (this.voceSelezionata.ID_VOCE > 0 ? 'ha modificato la voce "' : 'ha creato una nuova voce "') + this.voceSelezionata.TITOLO_VOCE + '"');
					this.getAttivita();

					if (continua) {
						this.voceSelezionata = {
							FK_ID_ATTIVITA: this.voceSelezionata.FK_ID_ATTIVITA,
							FK_ID_PROGETTO: this.voceSelezionata.FK_ID_PROGETTO,
							ID_VOCE: 0,
							TITOLO_VOCE: '',
							NOTE: '',
							FK_ID_AZIENDA: this.progetto.FK_ID_AZIENDA || null,
							FK_ID_AZIENDA_FORNITORE: null,
							QUANTITY_PRICE: 1,
							DAYS_PRICE: 1,
							QUANTITY_COST_ESPOSTO: 1,
							DAYS_COST_ESPOSTO: 1,
							UNIT_PRICE: 0,
							TOTAL_PRICE: 0,
							FK_ID_IVA_PREZZO: null,
							UNIT_COST_ESPOSTO: 0,
							TOTAL_COST_ESPOSTO: 0,
							FK_ID_IVA_COSTO: null,
							UNIT_COST_PRIVATO: 0,
							TOTAL_COST_PRIVATO: 0,
							FK_ID_IVA_COMMISSIONI: null,
							FLG_DA_CALCOLARE: 1,
							FLG_OMAGGIO_UNIT_PRICE: 0,
							FLG_OMAGGIO_TOTAL_PRICE: 0,
							FLG_OMAGGIO_UNIT_COST_ESPOSTO: 0,
							FLG_OMAGGIO_UNIT_COST_PRIVATO: 0,
							FLG_OMAGGIO_TOTAL_COST_PRIVATO: 0,
						};
					} else {
						this.filters.closePopUp("popUpVoce");
					}
				}
			});
		},

		eliminaVoce(voce) {
			utils.alert.confirm('Sei sicuro di voler eliminare questa voce?', () => {
				utils.ajax('theb/voci/delete', { ID_VOCE: voce.ID_VOCE }, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Voce eliminata con successo.');
						utils.notifiche.invia(this, 'VOCE_ELIMINA', 'ha eliminato la voce "' + voce.TITOLO_VOCE + '"');
						this.getAttivita();
					}
				});
			}, this.$root);
		},

		eliminaDefinitivamenteVoce(voce) {
			utils.alert.confirm('ATTENZIONE: Eliminare DEFINITIVAMENTE questa voce? Azione irreversibile.', () => {
				utils.ajax('theb/voci/harddelete', { ID_VOCE: voce.ID_VOCE }, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Voce eliminata definitivamente.');
						this.getAttivita();
					}
				});
			}, this.$root);
		},

		apriAzioniVoce(payload) {
			const { azione, voce, attivita } = payload;
			this.vocePerAzioni = voce;
			this.attivitaPerAzioniVoce = attivita;

			switch (azione) {
				case 'toggle-attivo':
					voce.FLG_ATTIVO_VOCE = voce.FLG_ATTIVO_VOCE == 1 ? 0 : 1;
					utils.ajax('theb/voce/update', {
						ID_VOCE: voce.ID_VOCE,
						FLG_ATTIVO: voce.FLG_ATTIVO_VOCE,
						TITOLO: voce.TITOLO_VOCE,
					}, (response) => {
						if (response.esito == 0) {
							this.getAttivita();
						}
					});
					break;
				case 'modifica':
					this.modificaVoce(voce, attivita);
					break;
				case 'aggiungi-preferito':
					this.vocePreferitaTemp = utils.clone(voce);
					this.vocePreferitaTemp.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
					this.filters.openPopUp("popUpAggiungiVocePreferita");
					break;
				case 'elimina':
					this.eliminaVoce(voce);
					break;
				case 'elimina-definitivamente':
					this.eliminaDefinitivamenteVoce(voce);
					break;
				case 'ripristina':
					utils.alert.confirm(`Ripristinare la voce "${voce.TITOLO_VOCE}"?`, () => {
						utils.ajax('theb/voci/ripristina', { ID_VOCE: voce.ID_VOCE }, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Voce ripristinata.');
								utils.notifiche.invia(this, 'VOCE_MODIFICA', 'ha ripristinato la voce "' + voce.TITOLO_VOCE + '"');
								this.getAttivita();
							}
						});
					}, this.$root);
					break;
			}
		},

		azioneToggleAttivoVoce() {
			this.vocePerAzioni.FLG_ATTIVO_VOCE = this.vocePerAzioni.FLG_ATTIVO_VOCE == 1 ? 0 : 1;
			utils.ajax('theb/voce/update', {
				ID_VOCE: this.vocePerAzioni.ID_VOCE,
				FLG_ATTIVO: this.vocePerAzioni.FLG_ATTIVO_VOCE,
				TITOLO: this.vocePerAzioni.TITOLO_VOCE,
			}, (response) => {
				if (response.esito == 0) {
					this.filters.closePopUp('popUpAzioniVoci');
					this.getAttivita();
				}
			});
		},

		azioneModificaVoce() {
			this.filters.closePopUp('popUpAzioniVoci');
			this.modificaVoce(this.vocePerAzioni, this.attivitaPerAzioniVoce);
		},

		apriNuovoFornitore() {
			this.$refs.schedaAziendaFornitore.openSchedaAzienda({ ID_AZIENDA: 0, personaGiuridica: {} });
		},

		onFornitoreCreato(azienda) {
			this.$refs.schedaAziendaFornitore.chiudi();
			if (azienda?.ID_AZIENDA > 0) {
				this.voceSelezionata.FK_ID_AZIENDA_FORNITORE = azienda.ID_AZIENDA;
			}
		},

		azioneEliminaVoce() {
			this.filters.closePopUp('popUpAzioniVoci');
			this.eliminaVoce(this.vocePerAzioni);
		},
		azioneAggiungiPreferito() { 
			this.vocePreferitaTemp = utils.clone(this.vocePerAzioni); 
			this.vocePreferitaTemp.FK_ID_UTENTE = this.$root.utente.ID_UTENTE; 
			this.filters.closePopUp("popUpAzioniVoci"); 
			this.filters.openPopUp("popUpAggiungiVocePreferita"); 
		},

		apriAzioni(payload) {
			const { azione, attivita } = payload;
			this.attivitaPerAzioni = attivita;

			switch (azione) {
				case 'aggiungi-voce':
					this.creaVoce(attivita);
					break;
				case 'aggiungi-sotto-attivita':
					this.creaAttivita({ FK_ID_ATTIVITA: attivita.ID_ATTIVITA });
					break;
				case 'importa-voce-preferita':
					this.apriImportaVocePreferita(attivita);
					break;
				case 'modifica':
					this.modificaAttivita(attivita);
					break;
				case 'elimina':
					utils.alert.confirm('Nascondere questa attività e tutti i suoi figli?', () => {
						utils.ajax('theb/attivita/delete', {
							ID_ATTIVITA: attivita.ID_ATTIVITA,
							CASCADE: 1
						}, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Attività eliminata con successo.');
								this.getAttivita();
							}
						});
					}, this.$root);
					break;
				case 'elimina-definitivamente':
					utils.alert.confirm('ATTENZIONE: Eliminare DEFINITIVAMENTE questa attività e tutti i suoi figli? Azione irreversibile.', () => {
						utils.ajax('theb/attivita/harddelete', {
							ID_ATTIVITA: attivita.ID_ATTIVITA,
							CASCADE: 1
						}, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Attività eliminata definitivamente.');
								this.getAttivita();
							}
						});
					}, this.$root);
					break;
				case 'ripristina':
					utils.alert.confirm(`Ripristinare l'attività "${attivita.TITOLO}" e tutti i suoi figli?`, () => {
						utils.ajax('theb/attivita/ripristina', {
							ID_ATTIVITA: attivita.ID_ATTIVITA,
							CASCADE: 1
						}, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Attività ripristinata.');
								this.getAttivita();
							}
						});
					}, this.$root);
					break;
			}
		},

		apriAzioniSpesa({ azione, notaSpesa }) {
			switch (azione) {
				case 'modifica':
					this.notaSpesaInEdit = notaSpesa;
					this.showModalNuovaSpesa = true;
					break;
				case 'elimina':
					if (confirm('Sei sicuro di voler eliminare questa nota spesa?')) {
						utils.ajax('theb/notaspesa/delete', { ID_NOTA_SPESA: notaSpesa.ID_NOTA_SPESA }, (res) => {
							if (res.esito == 0) {
								this.getNoteSpese();
								utils.alert.success('Nota spesa eliminata', 'success');
							} else {
								utils.alert.warning('Errore nell\'eliminazione', 'danger');
							}
						});
					}
					break;
			}
		},

		azioneAggiungiVoce() {
			this.filters.closePopUp('popUpAzioni');
			this.creaVoce(this.attivitaPerAzioni);
		},

		azioneAggiungiSottoAttivita() {
			this.filters.closePopUp('popUpAzioni');
			this.creaAttivita({ FK_ID_ATTIVITA: this.attivitaPerAzioni.ID_ATTIVITA });
		},

		azioneModifica() {
			this.filters.closePopUp('popUpAzioni');
			this.modificaAttivita(this.attivitaPerAzioni);
		},

		azioneElimina() {
			this.filters.closePopUp('popUpAzioni');
			utils.alert.confirm('Nascondere questa attività e tutti i suoi figli?', () => {
				utils.ajax('theb/attivita/delete', {
					ID_ATTIVITA: this.attivitaPerAzioni.ID_ATTIVITA,
					CASCADE: 1
				}, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Attività eliminata con successo.');
						this.getAttivita();
					}
				});
			}, this.$root);
		},

		azioneEliminaDefinitivamente() {
			this.filters.closePopUp('popUpAzioni');
			utils.alert.confirm('ATTENZIONE: Eliminare DEFINITIVAMENTE questa attività e tutti i suoi figli? Azione irreversibile.', () => {
				utils.ajax('theb/attivita/harddelete', {
					ID_ATTIVITA: this.attivitaPerAzioni.ID_ATTIVITA,
					CASCADE: 1
				}, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Attività eliminata definitivamente.');
						this.getAttivita();
					}
				});
			}, this.$root);
		},

		ordineAttivitaChanged() {
			const attivitaAggiornate = this.paginatedList.arr.map((att, i) => ({
				ID_ATTIVITA: att.ID_ATTIVITA,
				ORDINE: i + 1
			}));
			utils.ajax("theb/attivita/ordine", {
				array: attivitaAggiornate,
				ID_PROGETTO: this.progetto.ID_PROGETTO
			}, (response) => {
				if (response.esito == 0) {
					utils.alert.success("Ordine attività salvato con successo.");
					this.getAttivita();
				}
			});
		},

		onRootAttivitaDragStart(evt) {
			document.body.classList.add('is-dragging');
			const attivita = this.attivitaList[evt.oldIndex];
			this.draggingRootAttivita = {
				type: 'attivita',
				item: attivita,
				sourceParentId: null, // null = root level
				sourceIndex: evt.oldIndex,
			};
		},

		onRootAttivitaDragEnd() {
			document.body.classList.remove('is-dragging');
			this.draggingRootAttivita = null;
		},

		onRootAttivitaMove(evt) {
			// Blocca voci dal root level (solo attività possono stare al root)
			if (evt.draggedContext && evt.draggedContext.element && evt.draggedContext.element.ID_VOCE !== undefined) {
				return false;
			}
			// Permetti il movimento di attività tra drag-list diverse (cross-level, incluso da sotto-attività al root)
			return true;
		},

		async salvaOrdinamento() {
			this.saving = true;

			try {
				// Step 1: Raccogli tutti gli ordini dall'albero corrente
				const allUpdates = this.collectAllOrdersFromTree();

				// Step 2: Chiamate API batch per attività
				if (allUpdates.attivita.length > 0) {
					await new Promise((resolve, reject) => {
						utils.ajax('theb/attivita/ordine', {
							array: allUpdates.attivita,
							ID_PROGETTO: this.progetto.ID_PROGETTO
						}, (response) => {
							if (response.esito == 0) {
								resolve();
							} else {
								reject(new Error("Errore salvataggio attività"));
							}
						});
					});
				}

				// Step 3: Chiamate API batch per voci (raggruppate per attività)
				for (const [idAttivita, voci] of Object.entries(allUpdates.vociByAttivita)) {
					await new Promise((resolve, reject) => {
						utils.ajax('theb/voci/ordine', {
							array: voci,
							ID_ATTIVITA: parseInt(idAttivita)
						}, (response) => {
							if (response.esito == 0) {
								resolve();
							} else {
								reject(new Error(`Errore salvataggio voci attività ${idAttivita}`));
							}
						});
					});
				}

				// Step 4: Ricarica albero aggiornato dal backend
				await new Promise((resolve) => {
					this.getAttivita();
					this.$nextTick(resolve);
				});

				this.hasUnsavedChanges = false;
				this.editMode = false; // Torna alla modalità normale con filtri
				utils.alert.success("Ordinamento salvato con successo");

			} catch (error) {
				utils.alert.danger("Errore nel salvataggio: " + error.message);
			} finally {
				this.saving = false;
			}
		},

		collectAllOrdersFromTree() {
			const attivita = [];
			const vociByAttivita = {};

			const traverseAttivita = (att, index, parentId = null) => {
				// Raccogli ordine attività E relazione padre-figlio
				attivita.push({
					ID_ATTIVITA: att.ID_ATTIVITA,
					ORDINE: index + 1,
					FK_ID_ATTIVITA: parentId // null per root, ID_ATTIVITA del parent per sotto-attività
				});

				// Raccogli ordine voci di questa attività E relazione con attività
				if (att.VOCI && att.VOCI.length > 0) {
					vociByAttivita[att.ID_ATTIVITA] = att.VOCI.map((v, i) => ({
						ID_VOCE: v.ID_VOCE,
						ORDINE: i + 1,
						FK_ID_ATTIVITA: att.ID_ATTIVITA // Assicura che la voce appartenga a questa attività
					}));
				}

				// Ricorsione su sotto-attività
				if (att.SOTTO_ATTIVITA && att.SOTTO_ATTIVITA.length > 0) {
					att.SOTTO_ATTIVITA.forEach((sub, i) => {
						traverseAttivita(sub, i, att.ID_ATTIVITA); // Passa l'ID del parent
					});
				}
			};

			// Attraversa l'albero root
			this.arrayAttivita.forEach((att, i) => {
				traverseAttivita(att, i, null); // null = root level
			});

			return { attivita, vociByAttivita };
		},

		onRootAttivitaChange(evt) {
			// Aggiorna FK_ID_ATTIVITA per cross-level moves (spostamento a root = null)
			if (evt.added) {
				evt.added.element.FK_ID_ATTIVITA = null;
			}

			// Il drag modifica già arrayAttivita in place (quando editMode = true)
			// Segna solo che ci sono modifiche non salvate
			this.hasUnsavedChanges = true;
		},

		disabilitaRiordino() {
			if (this.hasUnsavedChanges) {
				const conferma = confirm('Hai modifiche non salvate. Vuoi davvero annullare?');
				if (!conferma) return;

				// Ricarica i dati originali dal backend
				this.getAttivita();
			}
			this.editMode = false;
			this.hasUnsavedChanges = false;
		},


		tornaAProgetti() {
			global.router.push('/Progetti');
		},

		esportaBudgetExcel() {
			// Usa la modalità di esportazione salvata nel progetto, default 1005 (Multi-Foglio)
			
			window.open(utils.BASE_API + "theb/report?ID_REPORT=" + idReport + "&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + "&LANG=" + this.$root.currentLang + utils.getSessionToken());
		},

		esportaProgettoExcel: function () {
			var url = utils.BASE_API + "theb/report?ID_REPORT=4&FORMATO=2&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + utils.getSessionToken();
			window.open(url);
		},

		apriModalitaEsportazione: function () {
			this.modalitaEsportazioneSelezionata = null;
			this.filters.openPopUp('popUpModalitaEsportazione');
		},

		scaricaTemplateOffline: function () {
			utils.downloadExcel('theb/attivita-voci/export', {
				FK_ID_PROGETTO:  this.progetto.ID_PROGETTO,
				FK_ID_REVISIONE: this.revisioneCorrente.ID_REVISIONE,
			}, 'AttivitaVoci_template.xlsx');
		},

		apriImportaExcelOffline: function () {
			this.showImportAttivitaExcel = true;
		},

		confermaEsportazioneExcel: function () {
			if (!this.modalitaEsportazioneSelezionata) {
				utils.alert.warning('Seleziona una modalità di esportazione');
				return;
			}
			const idReport = this.modalitaEsportazioneSelezionata;
			this.filters.closePopUp('popUpModalitaEsportazione');
			window.open(utils.BASE_API + "theb/report?ID_REPORT=" + idReport + "&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + "&LANG=" + this.$root.currentLang + utils.getSessionToken());
		},

		caricaModalitaEsportazione: function () {
			utils.ajax('shared/tipologica', { ID_TIPOLOGICA: 59 }, (response) => {
				if (response.esito == 0 && response.data.opzioni) {
					this.arrayModalitaEsportazione = response.data.opzioni;
				}
			});
		},

		esportaBudgetPdf() {
			window.open(utils.BASE_API + "theb/report?ID_REPORT=1006&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + "&LANG=" + this.$root.currentLang + utils.getSessionToken());
		},

		stampeOrdine: function (idReport) {
			window.open(utils.BASE_API + "core/report?ID_REPORT=" + idReport + "&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + utils.getSessionToken());
		},

		apriFlatPopUpAggiungiVocePreferita() {
			this.vocePreferitaTemp = utils.clone(this.voceSelezionata);
			this.vocePreferitaTemp.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			this.filters.openPopUp("popUpAggiungiVocePreferita");
		},

		salvaVocePreferitaConAzienda() {
			this.salvandoVocePreferita = true;
			const payload = { ...this.vocePreferitaTemp };
			payload.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			payload.FK_ID_AZIENDA = this.progetto.FK_ID_AZIENDA;
			payload.TITOLO = payload.TITOLO_VOCE;
			payload.FLG_ATTIVO = 1;

			utils.ajax('theb/vocepreferita/insert', payload, (response) => {
				this.salvandoVocePreferita = false;
				if (response.esito == 0) {
					utils.alert.success("Voce preferita salvata con successo (con azienda).");
					this.filters.closePopUp("popUpAggiungiVocePreferita");
					this.filters.closePopUp("popUpVoce");
				} else {
					utils.alert.danger(response.messaggio || "Errore nel salvataggio della voce preferita.");
				}
			});
		},

		salvaVocePreferitaDueVersioni() {
			this.salvandoVocePreferita = true;
			const payload = { ...this.vocePreferitaTemp };
			payload.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			payload.TITOLO = payload.TITOLO_VOCE;

			// Prima versione: CON azienda
			const payloadConAzienda = { ...payload };
			payloadConAzienda.FK_ID_AZIENDA = this.progetto.FK_ID_AZIENDA;
			payloadConAzienda.FLG_ATTIVO = 1;
			// Seconda versione: SENZA azienda
			const payloadSenzaAzienda = { ...payload };
			payloadSenzaAzienda.FK_ID_AZIENDA = null;
			payloadSenzaAzienda.FLG_ATTIVO = 1;

			utils.ajax('theb/vocepreferita/insert', payloadConAzienda, (response) => {
				if (response.esito == 0) {
					utils.ajax('theb/vocepreferita/insert', payloadSenzaAzienda, (response2) => {
						this.salvandoVocePreferita = false;
						if (response2.esito == 0) {
							utils.alert.success("Voce preferita salvata in entrambe le versioni (con e senza azienda).");
							this.filters.closePopUp("popUpAggiungiVocePreferita");
							this.filters.closePopUp("popUpVoce");
						} else {
							utils.alert.danger(response2.messaggio || "Errore nel salvataggio della versione senza azienda.");
						}
					});
				} else {
					this.salvandoVocePreferita = false;
					utils.alert.danger(response.messaggio || "Errore nel salvataggio della voce preferita.");
				}
			});
		},

		salvaVocePreferitaSenzaAzienda() {
			this.salvandoVocePreferita = true;
			const payload = { ...this.vocePreferitaTemp };
			payload.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			payload.FK_ID_AZIENDA = null;
			payload.TITOLO = payload.TITOLO_VOCE;
			payload.FLG_ATTIVO = 1;

			utils.ajax('theb/vocepreferita/insert', payload, (response) => {
				this.salvandoVocePreferita = false;
				if (response.esito == 0) {
					utils.alert.success("Voce preferita salvata con successo (senza azienda).");
					this.filters.closePopUp("popUpAggiungiVocePreferita");
					this.filters.closePopUp("popUpVoce");
				} else {
					utils.alert.danger(response.messaggio || "Errore nel salvataggio della voce preferita.");
				}
			});
		},

	},

	computed: {
		isReadOnly() {
			return this.revisioneVisualizzata && this.revisioneCorrente && this.revisioneVisualizzata.ID_REVISIONE != this.revisioneCorrente.ID_REVISIONE;
		},

		paginatedList() {
			return global.utils.inGridRicorsiva(this.arrayAttivita, this.search, this.ordinamento, 'VOCI');
		},
		paginatedListStorico() {
			var arr =  global.utils.inGrid(this.revisioni,this.searchStorico);
			return arr;
		},

		paginatedVociPreferiteImport() {
			return global.utils.inGrid(this.vociPreferitePerImport, this.searchVocePreferitaImport);
		},

		idAttivitaSelezionateCorrente() {
			return this.attivitaSelezionatePerImport
				.filter(a => a.ID_REVISIONE == this.revisioneSelezionataPerImport)
				.map(a => a.ID_ATTIVITA);
		},

		basketCountsByRevision() {
			const counts = {};
			this.revisioniPerImport.forEach(rev => {
				counts[rev.ID_REVISIONE] = this.attivitaSelezionatePerImport
					.filter(a => a.ID_REVISIONE == rev.ID_REVISIONE).length;
			});
			return counts;
		},

		selectAllAttivitaImport() {
			return this.attivitaPerImport.length > 0
				&& this.attivitaPerImport.every(a => this.idAttivitaSelezionateCorrente.includes(a.ID_ATTIVITA));
		},

		// Array da usare per il draggable e il v-for
		// In editMode: usa arrayAttivita (no filtri, drag attivo)
		// In modalità normale: usa paginatedList.arr (filtri attivi, drag disabilitato)
		attivitaList() {
			return this.editMode ? this.arrayAttivita : this.paginatedList.arr;
		},

		attivitaFlat() {
			var risultato = [];
			this.flattenAttivita(this.arrayAttivita, risultato);
			return risultato;
		},

		ivaModaleSommario() {
			const codiceIva = (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.voceSelezionata.FK_ID_IVA_PREZZO
			);
			const { aliquota, tipo } = this.parseCodiceIva(codiceIva);
			const prezzo = parseFloat(this.voceSelezionata.TOTAL_PRICE) || 0;
			const importo = this.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo == 'esclusa' ? prezzo + importo : prezzo;
			return {
				aliquota,
				importo: importo.toFixed(2),
				totale: totale.toFixed(2),
			};
		},

		ivaAcquistoSommario() {
			const codiceIva = (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.voceSelezionata.FK_ID_IVA_COSTO
			);
			const { aliquota, tipo } = this.parseCodiceIva(codiceIva);
			const prezzo = parseFloat(this.voceSelezionata.TOTAL_COST_ESPOSTO) || 0;
			const importo = this.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo == 'esclusa' ? prezzo + importo : prezzo;
			return {
				aliquota,
				importo: importo.toFixed(2),
				totale: totale.toFixed(2),
			};
		},

		ivaCommissioniSommario() {
			const codiceIva = (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.voceSelezionata.FK_ID_IVA_COMMISSIONI
			);
			const { aliquota, tipo } = this.parseCodiceIva(codiceIva);
			const prezzo = parseFloat(this.voceSelezionata.TOTAL_COST_PRIVATO) || 0;
			const importo = this.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo == 'esclusa' ? prezzo + importo : prezzo;
			return {
				aliquota,
				importo: importo.toFixed(2),
				totale: totale.toFixed(2),
			};
		},

		getTotali() {
			var attivita = 0;
			var voci = 0;
			var budget = 0;
			var costoEsposto = 0;
			var costoPrivato = 0;

			var sommaRicorsiva = (nodi) => {
				for (var i = 0; i < nodi.length; i++) {
					var nodo = nodi[i];
					if (nodo.FLG_ATTIVO == 1) attivita++;
					if (nodo.VOCI) {
						for (var v = 0; v < nodo.VOCI.length; v++) {
							var voce = nodo.VOCI[v];
							if (voce.FLG_ATTIVO_VOCE == 1 && voce.FLG_DA_CALCOLARE == 1) {
								voci++;
							}
						}
					}
					if (nodo.SOTTO_ATTIVITA && nodo.SOTTO_ATTIVITA.length > 0) {
						sommaRicorsiva(nodo.SOTTO_ATTIVITA);
					}
				}
			};

			sommaRicorsiva(this.arrayAttivita);

			// Calcola totali IVA (prezzo, costo, commissioni)
			let totaleIva = 0;
			let totaleIvaCosto = 0;
			let totaleIvaCommissioni = 0;
			const sumIvaRicorsiva = (nodi) => {
				for (const nodo of nodi) {
					if (nodo.FLG_ATTIVO == 1) {
						for (const voce of (nodo.VOCI || [])) {
							if (voce.FLG_ATTIVO_VOCE == 1 && voce.FLG_DA_CALCOLARE == 1) {
								const codiceIva = (this.$root.arrayCodiciIva || []).find(
									c => c.ID_OPZIONE_TIPOLOGICA == voce.FK_ID_IVA_PREZZO
								);
								totaleIva += this.calcolaImportoIva(voce.TOTAL_PRICE, codiceIva);

								const codiceIvaCosto = (this.$root.arrayCodiciIva || []).find(
									c => c.ID_OPZIONE_TIPOLOGICA == voce.FK_ID_IVA_COSTO
								);
								totaleIvaCosto += this.calcolaImportoIva(voce.TOTAL_COST_ESPOSTO, codiceIvaCosto);

								const codiceIvaCommissioni = (this.$root.arrayCodiciIva || []).find(
									c => c.ID_OPZIONE_TIPOLOGICA == voce.FK_ID_IVA_COMMISSIONI
								);
								totaleIvaCommissioni += this.calcolaImportoIva(voce.TOTAL_COST_PRIVATO, codiceIvaCommissioni);
							}
						}
						sumIvaRicorsiva(nodo.SOTTO_ATTIVITA || []);
					}
				}
			};
			sumIvaRicorsiva(this.arrayAttivita);

			// Somma i subtotali già calcolati dal backend per le attività root
			for (var i = 0; i < this.arrayAttivita.length; i++) {
				var att = this.arrayAttivita[i];
				if (att.FLG_ATTIVO == 1) {
					budget += parseFloat(att.SUBTOTALE_BUDGET) || 0;
					costoEsposto += parseFloat(att.SUBTOTALE_ESPOSTO) || 0;
					costoPrivato += parseFloat(att.SUBTOTALE_PRIVATO) || 0;
				}
			}

			// Calcola FEE per voce
			var fee = 0;
			var sumFeeRicorsiva = (nodi) => {
				for (const nodo of nodi) {
					if (nodo.FLG_ATTIVO == 1) {
						for (const voce of (nodo.VOCI || [])) {
							if (voce.FLG_ATTIVO_VOCE == 1 && voce.FLG_DA_CALCOLARE == 1) {
								fee += (parseFloat(voce.TOTAL_PRICE) || 0) * (parseFloat(voce.FEE) || 0) / 100;
							}
						}
						sumFeeRicorsiva(nodo.SOTTO_ATTIVITA || []);
					}
				}
			};
			sumFeeRicorsiva(this.arrayAttivita);

			return {
				ATTIVITA: attivita,
				VOCI: voci,
				BUDGET: budget.toFixed(2),
				COSTO_ESPOSTO: costoEsposto.toFixed(2),
				COSTO_PRIVATO: costoPrivato.toFixed(2),
				TOTALE_IVA: totaleIva.toFixed(2),
				TOTALE_CON_IVA: (budget + totaleIva).toFixed(2),
				TOTALE_IVA_COSTO: totaleIvaCosto.toFixed(2),
				TOTALE_CON_IVA_COSTO: (costoEsposto + totaleIvaCosto).toFixed(2),
				TOTALE_IVA_COMMISSIONI: totaleIvaCommissioni.toFixed(2),
				TOTALE_CON_IVA_COMMISSIONI: (costoPrivato + totaleIvaCommissioni).toFixed(2),
				FEE: fee.toFixed(2),
				GRAND_TOTAL: (budget + fee).toFixed(2),
				MARGINE: (budget + fee + costoPrivato - costoEsposto).toFixed(2),
			}
		},

	},

	created: function () {
		global.utils.BASE_API = process.env.VUE_APP_API_URL;
		this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
		this.caricaModalitaEsportazione();
		this.getAttivita();
		this.caricaRevisioni();
		this.getNoteSpese();

	}


}
</script>

<style scoped>
	body.is-dragging,body.is-dragging *{user-select: none !important;-webkit-user-select: none !important;-moz-user-select: none !important;-ms-user-select: none !important}
	.thead-bordered th{border: 1px solid #dee2e6}
	.ghost-item{opacity: 0 !important;visibility: hidden}
	.chosen-item{opacity: 0.8;background: #e3f2fd;border: 2px dashed #2196f3 !important}
	.root-attivita-container{min-height: 20px;transition: all 0.2s ease}
	.root-attivita-container.root-attivita-empty{min-height: 80px;background: rgba(33, 150, 243, 0.03);border: 2px dashed rgba(33, 150, 243, 0.3);border-radius: 8px;margin: 8px}
	.root-drop-placeholder{display: flex;align-items: center;justify-content: center;padding: 24px;color: #999;font-size: 0.85rem;font-weight: 400;opacity: 0.7;user-select: none;pointer-events: none}
	.dragging-item{opacity: 0.8;transform: rotate(2deg);cursor: grabbing !important}
	.table-responsive{overflow: visible !important}
	.div_table_resp.tableFixHead,#tableFixHead{overflow-y: auto !important}
	.dropdown-menu{z-index: 9999 !important}
	td{overflow: visible !important}
	tr{overflow: visible !important}
	.dropdown-menu{z-index: 99999 !important;position: absolute !important}
	.table tbody,.table tr,.table td,.table th{overflow: visible !important;position: static !important}
	.table thead{overflow: visible !important}	#tableFixHead .dropdown-menu{position: fixed !important}
	.empty-attivita-placeholder{display: flex;align-items: center;justify-content: center;padding: 24px;color: #adb5bd;font-size: 0.85rem;font-weight: 400;border: 2px dashed #dee2e6;border-radius: 6px;background-color: #f8f9fa;margin: 6px;user-select: none;pointer-events: none}
</style>


